import React, { useContext } from "react";
import "./locationFilter.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { EmployeesContext } from "../../store";
import FilterLocationButton from "../filter-location-button/filter-location-button.component";

export default function LocationFilter(props: any) {

  const [t] = useTranslation();

  const {activeFilters, setActiveFilter, filters} = useContext(EmployeesContext);

  const toggleActiveFilter = (handledFilter: any) => {
    setActiveFilter(handledFilter);
  }

  const isActiveTask = (location : any) => {
    return activeFilters.includes(location);
  }
  
  return (
    <div>
      <div className="title">{t("filter by houses")}</div>
      <div className="filters">
        {filters.map((location: any, index: number) => (
          <div className="location" key={index}>
            <FilterLocationButton
              location={location}
              toggleActiveFilter={toggleActiveFilter}
              activeFilters={activeFilters}
              state={isActiveTask(location)? 'active': ''
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
}
